import React,{Component} from  'react'
import * as actions from '../../redux/actions';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import DetailedHeader from '../../containers/Details/DetailedHeader';
import DetailedDescription from '../../containers/Details/DetailedDescription'
import AssessmentsOverview from './AssessmentsOverview';

class AssessmentsDetailedView extends Component{

    constructor (props) {
        super(props);
        this.state = {
            selectedTab: "SUMMARY",
            infoClicked: window.innerWidth < 768 ? false : true,
            searchClicked: false,
            load: "initial",
            status:"",
            data: {
                id: "",
                image: "",
                name: "",
                description: "",
                grades: "",
                texts: [],
                forms: [],
                printable:false,
                google_form_link:""
            }
        };
        this.selectTab = this.selectTab.bind(this);
        this.onInfoClick = this.onInfoClick.bind(this);
    }

    componentWillMount() {
        this.props.getAssessmentDetailsAction(this.props.params.uid);
    }

    componentWillReceiveProps(next) {
        if (next.assessmentDetails) {
            if (next.assessmentDetails.asyncStatus === "PENDING") {
                this.setState({status: "PENDING"});
            }
            else if (next.assessmentDetails.asyncStatus === "FAILURE") {
                this.setState({assessmentDetails: "FAILURE"});
            } else if (next.assessmentDetails.asyncStatus === "SUCCESS" && next.assessmentDetails.data.status === "FAILURE FOR PRINT ONLY USER") {
                this.setState({status: "FAILURE FOR PRINT ONLY USER"});
            } else if (next.assessmentDetails.asyncStatus === "SUCCESS" && next.assessmentDetails.data.status === "FAILURE FOR NOT APPROVED") {
                this.setState({status: "FAILURE FOR NOT APPROVED"});
            } else if (next.assessmentDetails.asyncStatus === "SUCCESS") {
                let data = {
                    id: next.assessmentDetails.data._id,
                    name: next.assessmentDetails.data.name,
                    publish: next.assessmentDetails.data.publish,
                    texts: next.assessmentDetails.data.mentorTexts,
                    grades: next.assessmentDetails.data.grades.join(", "),
                    forms: next.assessmentDetails.data.files.map(file => ({file, image: file + ".thumb.jpg"})),
                    description: '',
                    image: '',
                    printable:next.assessmentDetails.data.printable || false,
                    google_form_link:next.assessmentDetails.data.google_form_link,
                    showClassroomShareButtonLink: next.assessmentDetails.data.showClassroomShareButtonLink
                  };

                if(next.assessmentDetails.data.description.description) {
                    data.description = next.assessmentDetails.data.description.description;
                }
                else if(next.assessmentDetails.data.description.text) {
                    data.description = next.assessmentDetails.data.description.text;
                }
                
                if (next.assessmentDetails.data.image) {
                    data.image = next.assessmentDetails.data.image;
                }else if(next.assessmentDetails.data.files){
                    data.image = next.assessmentDetails.data.files[0]+".thumb.jpg";
                }

                this.setState({data, status: "SUCCESS"});
            }
        }
        if(next.params.uid!==this.props.params.uid){
            this.props.getAssessmentDetailsAction(next.params.uid);
        }
    }

    onInfoClick(infoClicked = !this.state.infoClicked){
        if(infoClicked) {
            this.onSearchClick(false);
        }
        return new Promise((resolve, reject) => {
            this.setState({infoClicked: infoClicked, load: ""}, () => {
                resolve();
            });
        });

    }

    onSearchClick=(searchClicked = !this.state.searchClicked)=>{
        if(searchClicked) {
            this.onInfoClick(false);
        }
        return new Promise((resolve, reject) => {
            this.setState({searchClicked: searchClicked, load: ""}, () => {
                resolve();
            });
        });
    };

    selectTab (tab) {

        this.setState({selectedTab: tab});
    }

    render(){
        return(
            <div className="detail-wrapper">
                <DetailedHeader publish={this.state.data.publish} file={Array.isArray(this.state.data.forms) && this.state.data.forms[0] && this.state.data.forms[0].file} name={this.state.data.name} onSearchClick={this.onSearchClick} infoClick={this.onInfoClick} itemType="Assessment" itemId={this.state.data.id} infoClicked={this.state.infoClicked} searchClicked={this.state.searchClicked}/>
                <div className={((this.state.infoClicked || this.state.searchClicked)?"some-area fill-height-or-more":"fill-height-or-more some-area-without-info")}>
                    <div className="detail-holder">
                        {this.state.status === "PENDING" &&
                            <div style={{paddingTop: "10px", textAlign: "center"}}>Loading....</div>
                        }
                        {this.state.status  === "FAILURE" &&
                            <div style={{paddingTop: "10px", textAlign: "center"}}>Error Loading Data</div>
                        }
                        {this.state.status  === "FAILURE FOR PRINT ONLY USER" &&
                            <div style={{paddingTop: "10px", textAlign: "center"}}>This resource is not approved for viewing on Fundamentals Unlimited. Please contact us at <a href="mailto:help@schoolwide.com" target="_blank" rel="noreferrer">help@schoolwide.com</a> for more information.</div>
                        }
                        {this.state.status  === "FAILURE FOR NOT APPROVED" &&
                            <div style={{paddingTop: "10px", textAlign: "center"}}>This resource is not approved for viewing on Fundamentals Unlimited. Please contact us at <a href="mailto:help@schoolwide.com" target="_blank" rel="noreferrer">help@schoolwide.com</a> for more information.</div>
                        }
                        {this.state.status === "SUCCESS" &&
                            <AssessmentsOverview
                                texts={this.state.data.texts}
                                forms={this.state.data.forms}
                                description={{text: this.state.data.description}}
                                grades={this.state.data.grades}
                            />
                        }
                    </div>
                    <div>
                        <DetailedDescription
                            file={Array.isArray(this.state.data.forms) && this.state.data.forms[0] && this.state.data.forms[0].file} //Assuming form[0] -> image
                            image={this.state.data.image}
                            name={this.state.data.name}
                            detailType='assessments'
                            printable={this.state.data.printable}
                            printableFile={Array.isArray(this.state.data.forms) && this.state.data.forms[0] && this.state.data.forms[0].file}
                            googleFormLink={this.state.data.google_form_link}
                            showClassroomShareButtonLink={this.state.data.showClassroomShareButtonLink}
                        />
                    </div>
                </div>
            </div>
        );
    };

}

const mapStateToProps = (state) => {
    return ({
        assessmentDetails : state.AssessmentDetails
    });
};

export default connect(mapStateToProps, actions)(withRouter(AssessmentsDetailedView))
